import type { HitsValueLineType } from "./RuleLogic";

// Which number style a rule uses, from its rule group + definition description
// (e.g. "Scores Both Teams Score"). Shared by the rule form (WatcherFormRule),
// which picks the stepper's steps/ranges from it, and My Rules (Rules.tsx),
// which formats the saved values the same way.
//
// Spread and Moneyline lines can be negative (favorite) or positive
// (underdog), so they're signed and not floored at zero like other lines.
// Markets quoted in American odds (e.g. MLB "First To Score", "Both Teams
// Score", NBA "Race To 10") are treated as Moneyline.
const MONEYLINE_STYLE_RULES = [
  "moneyline",
  "first to score",
  "both teams score",
  "draw no bet",
  "race to", // Race To 5/10/15/20/25, incl. quarter variants
  "win both halves",
  "highest scoring half",
  "team scores", // also Either Team Scores and the half variants
  // MLS yes-only player props (line fixed at 0.5): the user's number is the
  // payout price, which is what the backend evaluates (_PLAYER_YES_NO_PROP_SPECS).
  "at least one",
  // Price-only player props (_NBA_PLAYER_PRICE_ONLY_PROP_SPECS /
  // _PLAYER_OUTRIGHT_PROP_SPECS): the number is the payout price.
  "double double",
  "triple double",
  "first basket",
  "most points",
  "touchdown scorer", // NFL Touchdown / First / Last Touchdown Scorer
];

// Any rule containing "Odd/Even" or "Even/Odd" (spaces around the slash allowed).
const ODD_EVEN_RULE = /odd\s*\/\s*even|even\s*\/\s*odd/;

// NBA yes-only player props ("Any Assists", "Any Blocks", "1st Quarter Any
// Points", "Any Blocks + Steals", ...): the number is the yes payout price,
// which is what the backend evaluates (_NBA_PLAYER_PRICE_ONLY_PROP_SPECS).
const ANY_X_RULE = /\bany\b/;

export function getLineType(ruleText: string): HitsValueLineType | undefined {
  const text = ruleText.toLowerCase();
  if (text.includes("spread")) return "spread";
  if (
    MONEYLINE_STYLE_RULES.some((name) => text.includes(name)) ||
    ODD_EVEN_RULE.test(text) ||
    ANY_X_RULE.test(text)
  )
    return "moneyline";
  return undefined;
}
